import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../models/invoice';
import { InvoicesService } from '../services/invoices.service';
import { InvoiceFilter } from '../../models/invoice-filter';
import * as moment from 'moment';
import {WeekInvoices} from './invoice-week-table/invoice-week-table.component';

@Component({
	selector: 'app-invoices-week-select',
	templateUrl: 'invoice-week-selector.template.html'
})

/**
 * Component used for selecting a week of a specific year for a collection of invoices
 */
export class InvoiceWeekSelectorComponent
{
	get invoices_count(): WeekInvoices[]
  {
    return this._invoices_count;
  }

	@Input()
  set invoices_count(invoices_count: WeekInvoices[])
  {
    this._invoices_count = invoices_count;
    //todo check if we need this
    this.onInvoicesChange.emit(this._invoices_count);
  }

	_invoices_count: WeekInvoices[];

	/**
	 * Event that fires when a week has been selected. Contains a InvoiceFilter object.
	 *
	 * @type {EventEmitter<InvoiceFilter>}
	 */
	@Output() onWeekSelect = new EventEmitter<InvoiceFilter>();

	@Output() onYearSelect = new EventEmitter<number>();

	/**
	 * Event that fires when the collection of invoices has been changed. Contains a collection containing the new invoices.
	 *
	 * @type {EventEmitter<Invoice[]>}
	 */
	@Output() onInvoicesChange = new EventEmitter<WeekInvoices[]>();
	selectedYear: number = moment().year();

	/**
	 * InvoiceWeekSelector constructor
	 *
	 * @param {InvoicesService} invoicesService
	 */
	constructor(private invoicesService: InvoicesService)
	{
	}

	/**
	 * Selects a year and updates the invoices in the week invoice table.
	 *
	 * @param {number} year
	 *
	 * @returns void
	 */
	setYear(year: number)
	{
		this.selectedYear = year;
    this.onYearSelect.emit(this.selectedYear);

		this.invoicesService.getInvoicesCounts(year).subscribe(
			data => {
				this._invoices_count = data;
			}
		);
	}

	/**
	 * Selects a week. Emits the onWeekSelect event
	 *
	 * @param {number} week
	 *
	 * @returns void
	 */
	setWeek(week: number)
	{
		const filters: InvoiceFilter = {
			year: this.selectedYear,
			week: week,
			search: null
		};

		this.onWeekSelect.emit(filters);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-week-selector/invoice-week-selector.component.ts